<div class="w-100">
    <div tabindex="0" role="button"
        class="my-tab-focus w-100 d-flex justify-content-between align-items-center px-1 gap-2 c-pointer"
        (click)="goHome()">
        <div matRipple tabindex="0" role="button"
            class="my-tab-focus flex-grow-1 flex-md-grow-0 px-3 py-2 rounded-2 zx-border-gray-v-light"
            [class.zx-border-green]="isDarkMode">
            <div class="d-flex align-items-center gap-2" *ngIf="clusterName">
                <img [src]="'assets/images/branches/' + clusterName + '.png'" alt="choosen printing system icon"
                    class="zx-small-icon-size">
                <span class="zx-text-small">
                    {{ "choose-branch.naming." + clusterName | translate }}
                </span>
                <span class="spacer d-md-none"></span>
                <img *ngIf="!isDarkMode" src="/assets/images/tiny-arrow-icon.svg"
                    class="svg zx-tiny-icon-size c-pointer">
                <img *ngIf="isDarkMode" src="/assets/images/tiny-arrow-icon-green.svg"
                    class="svg zx-tiny-icon-size c-pointer">
            </div>
        </div>
        <div class="p-1 rounded-2 d-flex justify-content-center" mat-ripple>
            <img *ngIf="!isDarkMode" src="assets/images/chainge-icon.svg" class="svg zx-small-icon-size">
            <img *ngIf="isDarkMode" src="assets/images/chainge-icon-green.svg" class="svg zx-small-icon-size">
        </div>
    </div>

    <div class="w-100 opacity-50 mt-3">
        <hr class="m-0">
    </div>
</div>